(function() {
  'use strict';
  var header = document.querySelector('.site-header');
  if (header) window.addEventListener('scroll', function() { header.classList.toggle('scrolled', window.scrollY > 60); }, { passive: true });
  var menuToggle = document.getElementById('menuToggle'), menuClose = document.getElementById('menuClose'), mobileMenu = document.getElementById('mobileMenu');
  if (menuToggle && mobileMenu) menuToggle.addEventListener('click', function() { mobileMenu.classList.add('open'); document.body.style.overflow = 'hidden'; });
  if (menuClose && mobileMenu) menuClose.addEventListener('click', function() { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; });
  if (mobileMenu) mobileMenu.querySelectorAll('a').forEach(function(l) { l.addEventListener('click', function() { mobileMenu.classList.remove('open'); document.body.style.overflow = ''; }); });
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries) { entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); } }); }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.reveal').forEach(function(el) { obs.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function(el) { el.classList.add('visible'); }); }
  document.querySelectorAll('.product-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      var c = thumb.closest('.product-images'); if (!c) return;
      c.querySelectorAll('.product-thumb').forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var mainImg = c.querySelector('.product-main-img img');
      if (mainImg) mainImg.src = thumb.querySelector('img').src.replace(/width=\d+/, 'width=800');
    });
  });
  // Qty selector — keeps the visible stepper and the form's actual submitted quantity in sync
  document.querySelectorAll('.qty-selector').forEach(function(sel) {
    var num = sel.querySelector('.qty-num'), btns = sel.querySelectorAll('.qty-btn');
    var form = sel.closest('form');
    var hiddenQty = form ? form.querySelector('input[name="quantity"]') : null;
    function sync() { if (hiddenQty && num) hiddenQty.value = num.textContent; }
    sync();
    if (btns[0] && num) btns[0].addEventListener('click', function() { var v = parseInt(num.textContent) || 1; if (v > 1) num.textContent = v - 1; sync(); });
    if (btns[1] && num) btns[1].addEventListener('click', function() { var v = parseInt(num.textContent) || 1; num.textContent = v + 1; sync(); });
  });
  var collDesc = document.getElementById('collDesc');
  var descToggle = document.getElementById('descToggle');
  if (collDesc && descToggle) {
    descToggle.addEventListener('click', function() {
      var expanded = collDesc.classList.toggle('expanded');
      descToggle.textContent = expanded ? 'Show Less' : 'Read More';
    });
  }
 
  // Carousel touch handler — prevents vertical page drag when swiping horizontally
  document.querySelectorAll('.carousel-mobile').forEach(function(carousel) {
    var startX = 0, startY = 0, isDragging = false;
    carousel.addEventListener('touchstart', function(e) {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isDragging = false;
    }, { passive: true });
    carousel.addEventListener('touchmove', function(e) {
      var dx = Math.abs(e.touches[0].clientX - startX);
      var dy = Math.abs(e.touches[0].clientY - startY);
      if (dx > dy && dx > 5) {
        isDragging = true;
        e.stopPropagation();
      }
    }, { passive: true });
    carousel.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function(e) {
        if (isDragging) e.preventDefault();
      });
    });
  });
 
  // Promo tab & popup
  var promoTab = document.getElementById('promoTab');
  var promoOverlay = document.getElementById('promoOverlay');
  var promoClose = document.getElementById('promoClose');
  var promoCopy = document.getElementById('promoCopy');
  var promoCode = document.getElementById('promoCode');
  var promoForm = document.getElementById('promoForm');
  var promoCodeBox = document.getElementById('promoCodeBox');
  var promoDesc = document.getElementById('promoDesc');
  if (promoTab && promoOverlay) {
    promoTab.addEventListener('click', function() { promoOverlay.classList.add('open'); promoTab.classList.add('hidden'); });
    promoClose.addEventListener('click', function() { promoOverlay.classList.remove('open'); promoTab.classList.remove('hidden'); });
    promoOverlay.addEventListener('click', function(e) { if (e.target === promoOverlay) { promoOverlay.classList.remove('open'); promoTab.classList.remove('hidden'); } });
  }
  if (promoForm && promoCodeBox) {
    promoForm.addEventListener('submit', function(e) {
      e.preventDefault();
      var formData = new FormData(promoForm);
      fetch(promoForm.action, { method: 'POST', body: formData }).catch(function() {});
      promoForm.style.display = 'none';
      if (promoDesc) promoDesc.style.display = 'none';
      promoCodeBox.style.display = 'flex';
    });
  }
  if (promoCopy && promoCode) {
    promoCopy.addEventListener('click', function() {
      navigator.clipboard.writeText(promoCode.textContent).then(function() {
        promoCopy.textContent = 'Copied!';
        promoCopy.classList.add('copied');
        setTimeout(function() { promoCopy.textContent = 'Copy'; promoCopy.classList.remove('copied'); }, 2000);
      });
    });
  }

  // Buy Now — adds the item to cart via AJAX, then sends the shopper straight to checkout
  document.querySelectorAll('.buy-now-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      var formEl = btn.closest('form');
      var variantSelect = formEl ? formEl.querySelector('select[name="id"]') : null;
      if (variantSelect && variantSelect.value) variantId = variantSelect.value;
      var scope = btn.closest('.product-info') || btn.closest('.product-card');
      var qtyEl = scope ? scope.querySelector('.qty-num') : null;
      var qty = qtyEl ? (parseInt(qtyEl.textContent, 10) || 1) : 1;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
      }).then(function(r) {
        if (!r.ok) return r.json().then(function(d) { throw new Error((d && d.description) || 'Could not add to cart'); });
        window.location.href = '/checkout';
      }).catch(function() {
        window.location.href = '/cart/add?id=' + encodeURIComponent(variantId) + '&quantity=' + qty + '&return_to=' + encodeURIComponent('/checkout');
      });
    });
  });
 })();